import styled from 'styled-components';
import { FlexDiv } from '@shared/components/base/Div';
import { MobileScreen } from '@shared/components/styles/ConstantMediaQuery';
import { RoundedInputWithMagnifier } from '@shared/components/inputs/text-fields/RoundedInput';
import ColorConstants from '@shared/constants/ColorConstants';
import { Label } from '@shared/components/base/Text';

export const StyledInputWithSearch = styled(RoundedInputWithMagnifier)`
    border: 0px;
    background-color: ${ColorConstants['catskill-white']};

    @media ${MobileScreen} {
      width: 100%;
      margin-bottom: 10px;
    }
`;

export const MenuWrapper = styled(FlexDiv)`
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;

    @media ${MobileScreen} {
        width: 100%;
    }
`;

export const HeaderWrapper = styled(FlexDiv)`
    flex-wrap: wrap;
    margin: 20px 0px;
    width:100%;
    `;

export const HeaderLeft = styled.div`
    width:40%;

    @media screen and (max-width: 1000px){
        width: 100%;
    }
`;

export const HeaderRight = styled(FlexDiv)`
    align-items: center;
    justify-content: flex-end;
    width: 60%;

    @media screen and (max-width: 1000px){
        justify-content: flex-start;
        margin-bottom:30px;
        width: 100%;
    }

    @media ${MobileScreen} {
        justify-content: flex-end;
    }
`;

export const OBMAdvancedSettingsWrapper = styled(FlexDiv)`
    margin-right: 15px;

    @media ${MobileScreen} {
        width: 100%;
        margin: 0px 0px 10px 0px;
        padding: 0px 15px;
        flex-direction: row-reverse;
        justify-content: flex-end;
      }
`;

export const OBMAdvancedSettingsLabel = styled(Label)`
    color: ${ColorConstants['iris-blue']};
    padding: 4px 7px 0px 0px;

    @media ${MobileScreen} {
        padding-left: 7px;
      }
`;
